import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AuthProvider } from "@/auth/AuthProvider";
import { routes } from "./router";
import "./styles/globals.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root element");

const router = createBrowserRouter(routes);

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>,
);
